
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { offsetOneRow, offsetTwoRows, StateStyledNumberCell } from "../../Styles/ParticipationTableStyles";
import { CellWithValidator, StickyNumericHeader } from "../../../../components/Table/TableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { NumericFilter } from "../../../../components/Form/FormStyles";

export function PeopleImpactedNumberHeader() {
	return (
        <StickyNumericHeader
            style={{
                ...offsetOneRow,
                width: '160px',
                minWidth: '160px',
                maxWidth: '160px'
            }}>
            Indirectly impacted people (planting)
        </StickyNumericHeader>
    );
}

export function PeopleImpactedNumberFilter({
    filter,
    updateFilter
}: {
    filter: Filter;
    updateFilter: (filter: Filter) => void;
}) {
    return (
        <StickyNumericHeader style={{...offsetTwoRows}}>
            <CellWithValidator>
                <ValidateFilter
                    value={filter?.PeopleImpactedNumberValidated ?? ValidateFilterValue.Unset}
                    onChange={(e) =>
                        updateFilter({
                            ...filter,
                            PeopleImpactedNumberValidated: e.value
                        })
                    }
                />
                <NumericFilter
                    value={filter?.PeopleImpactedNumber ?? ''}
                    onChange={(e) =>
                        updateFilter({
                            ...filter,
                            PeopleImpactedNumber: e.target.value
                        })
                    }
                />
            </CellWithValidator>
        </StickyNumericHeader>
    );
}

export function PeopleImpactedNumberContent({ppn}: {ppn: EditedParticipation}) {
    return (
        <StateStyledNumberCell
            editStatus={ppn.EditStatus}
            modified={ppn.PlantingProjectId.modified}>
            <CellWithValidator>
                <span>
                    {ppn.PlantingProject.PeopleImpactedNumberValidated && <ValidatedIcon />}
                </span>
                <span>
                    {ppn.PlantingProject.PeopleImpactedNumber?.toLocaleString()}
                    {ppn.PlantingProject.PeopleImpactedLandType
                        ? `(${ppn.PlantingProject.PeopleImpactedLandType.toLocaleString()})`
                        : ''}
                </span>
            </CellWithValidator>
        </StateStyledNumberCell>
    );
}